import React, { useEffect, useState, useRef } from 'react';
import './CSS/style.css';
import RouteAnalysis from './RouteAnalysis';
import IncidentsReport from './IncidentsReport';
import SingleIncidentReport from './SingleIncidentReport';
import VesselReport from './VesselReport';
import TimelineReport from './TimelineReport';
import * as RO from './Javascript/ReportObjects.js';
import * as G from './Javascript/General.js';
import {getRouteTemplate, routeTemplateAnalyse} from './Javascript/AnalyseRoute.js';
import {logReportUsage} from './Javascript/UsageLog.js';
import Plot from 'react-plotly.js';

function Main() {
    const [is_loading, set_is_loading] = useState(true);
    const [load_error, set_load_error] = useState(false);
    const [failes_counter, setFailesCounter] = useState(0);
    const [route_template, set_route_template] = useState<RO.RouteTemplate | null>(null);
    const [analysed_route, set_analysed_route] = useState<RO.AnalysedRoute | null>(null);
    const map_ref = useRef(null);
    const current_date = new Date().toLocaleString('en-US', {weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', timeZone: 'UTC'});

    const coBrandLogo = (isFooter:boolean) => {
        const coLogo = RO.coBrandLogos.find(item => item[0] === RO.parent_uuid)?.[1] || null;
        if(isFooter) return coLogo ? <div className="coBrandLogoContFoot"><img className="coBrandLogo" src={coLogo} alt="Co-Brand Logo" /></div> : null;
        else return coLogo ? <div className="coBrandLogoCont"><img className="coBrandLogo" src={coLogo} alt="Co-Brand Logo" /></div> : null;
    }
    const fetchRoute = async () => {
        try{
            const res = await getRouteTemplate();
            set_route_template(res ? res : null);
        } catch (error) {
            console.error(error);
        }
    }

    const analyseRoute = async () => {
        try{
            if(route_template != null){
                if(route_template.vessel && route_template.vessel.name){
                    route_template.vessel.name = route_template.vessel.name.replace(/[^a-zA-Z0-9 ]/g, '');
                }
                const res = await routeTemplateAnalyse(route_template, RO.current_user);
                set_analysed_route(res ? res : null);
                if(!res) setFailesCounter(prevCounter => prevCounter + 1);
            }
            else{
                console.error("the route_template is empty");
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        logReportUsage('run');
    }, []);

    useEffect(() => {
        const fetchDetails = async () => {
            try {
                if(RO.report_type === "0" && failes_counter >= 5 && analysed_route == null){
                    set_load_error(true);
                    set_is_loading(false);
                    return;
                }
                if(RO.current_user){
                    const res = await G.getUserDetails(null, RO.current_user, null);
                    if(res && res.length > 0) G.setSessionUser(res[0]);
                }
                if(RO.report_type === "0"){
                    if (route_template == null) {
                        await fetchRoute();
                    }
                    if (route_template !== null && analysed_route == null && failes_counter < 5) {
                        await analyseRoute();
                    }else if(route_template == null && analysed_route == null && failes_counter < 5){
                        setFailesCounter(prevCounter => prevCounter + 1);
                        if(failes_counter > 2){
                            console.error("The route_template is still null attempt: ", failes_counter);
                        }
                    }
                }
            } catch (error) {
                console.error(error);
                // Thrown failures (e.g. token bootstrap) must also count towards the retry cap, or the spinner never resolves
                if(RO.report_type === "0" && analysed_route == null) setFailesCounter(prevCounter => prevCounter + 1);
            } finally {
                if (analysed_route !== null || RO.report_type !== "0") set_is_loading(false);
            }
        };

    fetchDetails();
    }, [route_template, analysed_route, failes_counter]);

  return (
    <div id="main_container">
    {load_error ? (
            <div id="loading">This report could not be loaded. Please try again, or contact support if the problem continues.</div>
        ) : is_loading ? (
            <div id="loading">Loading...<span className="rotating-arrows">&#8635;</span></div>
        ) : (
        <>
            <div id="downloading">Downloading <span id="page_gen_counter">  </span><span className="rotating-arrows">&#8635;</span></div>
            <div id="report_container">
                <div id="report_header">
                    <div className="inner_padding">
                        <div className="left">
                            <h1>{RO.report_name}</h1>
                        </div>
                        <div className="right">
                            <>
                            <img src={RO.host_logo}/>
                            {coBrandLogo(false)}
                            </>
                        </div>
                        <div className="clear_both"></div>
                    </div>
                    <div className="clear_both"></div>
                </div>
                {RO.report_type === "0" ? (
                    <RouteAnalysis route_analysis={analysed_route} map_ref={map_ref} />
                ) : RO.report_type === "1" ? (
                    <IncidentsReport map_ref={map_ref} />
                ) : RO.report_type === "2" ? (
                    <SingleIncidentReport map_ref={map_ref} />
                ) : RO.report_type === "3" ? (
                    <VesselReport />
                ) : RO.report_type === "4" ? (
                    <TimelineReport map_ref={map_ref} />
                ) : null}
                <div className="clear_both"></div>
                <div id="report_footer">
                    <div className="inner_padding">
                        <div className="left">
                            <p>{current_date} (UTC)</p>
                            <p id="page_numeration"></p>
                        </div>
                        <div className="center">
                            <p>{RO.host_url}</p>
                        </div>
                        <div className="right">
                            <>
                            <img src={RO.host_logo}/>
                            {coBrandLogo(true)}
                            </>
                        </div>
                        <div className="clear_both"></div>
                    </div>
                    <div className="clear_both"></div>
                </div>
            </div>
        </>
    )}
    </div>
  );
}

export default Main;